<template>
	<b-modal
		class="modal-card"
		v-model="isCardModalActive"
		:width="640"
		scroll="keep"
		aria-role="dialog"
		aria-modal
	>
		<div class="card">
			<div class="card-header">
				<div class="card-header-title"><b-icon class="card-head-icon titleIcon" icon="newspaper-variant" type="is-primary"></b-icon> {{item.workTitle}}</div>
			</div>
			<div class="card-image">
				<swiper
					class="portfolioPopSliderSwiper portfolioPop"
					:auto-update="true"
					:options="solutionSwiperOption"
					ref="portfolioPopSwiper"
				>
					<swiper-slide
						class="portfolioPopSlide portfolioPop"
						v-for="(item, index) in imgList"
						:key="index"
						>
						<b-image
							class="swiperImg"
							:src="$store.getters.getUrlPrefix + item"
							ratio="5by3"
							alt="Image">
						</b-image>
					</swiper-slide>
					<div class="swiper-pagination portfolioPop"  slot="pagination"></div>
				</swiper>
				<div class="swiper-button-prev portfolioPop"></div>
				<div class="swiper-button-next portfolioPop"></div>
			</div>
			<div class="card-content">
				<div class="media">
					<div class="media-left">
						<b-image
							style="width:80px;"
							:src="this.$store.getters.getUrlPrefix + item.clientLogo"
							alt="Image"
						></b-image>
					</div>
					<div class="media-content">
						{{item.clientName}}
					</div>
					<div class="media-right">
						<small class="txtYear">{{item.year}}</small>
					</div>
				</div>

				<div class="content">
					<div v-html="item.detail"></div>
				</div>
			</div>
		</div>
		<button class="modal-close is-large" aria-label="close" @click="$parent.close()"></button>
	</b-modal>
</template>

<script>
export default {
	name: 'ButtonLinkPage',
	components: {},
	data () {
		return {
			isCardModalActive: true,
			solutionSwiperOption: {
				loop: false,
				autoHeight: true,
				speed: 820,
				slidesPerView: 1,
				spaceBetween: 0,
				slidesPerGroup: 1,
				loopFillGroupWithBlank: true,
				autoplay: {
					delay: 5000
				},
				watchOverflow: true,
				touchStartPreventDefault: false,
				navigation: {
					nextEl: '.swiper-button-next.portfolioPop',
					prevEl: '.swiper-button-prev.portfolioPop'
				},
				pagination: {
					el: '.swiper-pagination.portfolioPop',
					type: 'bullets',
					clickable: true
				}
			}
		}
	},
	props: {
		item: {
			type: Object,
			default: function () {
				return {
					listTop: true,
					clientLogo: require('@/assets/images/partner-thumb-samsunglife@2x.png'),
					workTitle: '타이틀 명',
					clientName: '클라이언트 명',
					keyword: 'si',
					year: '2020',
					bgColor: 'rgba(0,48,85,0.9)',
					mainImg: '',
					detail: '설명 텍스트 (html)',
					detailImg: [
						{
							thumb: '',
							img: '',
							link: ''
						}
					],
					link: ''
				}
			}
		}
	},
	computed: {
		imgList: function () {
			let list = []
			list.push(this.item.mainImg)
			if (this.item.detailImg) {
				for (let imgItem in this.item.detailImg) {
					list.push(this.item.detailImg[imgItem].img || this.item.detailImg[imgItem].thumb)
				}
			}
			console.log('list:', list)
			return list
		}
	},
	methods: {
		sampleHandler () {}
	}
}
</script>

<style lang="scss">
@import '@/css/variables.scss';
.titleIcon {
	margin-right: 10px;
	vertical-align: middle;
}
.portfolioPopSlide .portfolioPop {
	.swiperImg {
		pointer-events: none;
	}
}
.card-image {
	.swiper-button-prev.portfolioPop,
	.swiper-button-next.portfolioPop {
		color: rgba($c-blue-white, 0.9);
		width: 16px; height: 27px;
	}
	.swiper-button-prev.portfolioPop:after,
	.swiper-button-next.portfolioPop:after {
		font-size: 32px;
	}
	.swiper-pagination-bullet {
		border-radius: 0;
		height: 4px;
	}
}
.txtYear {
	color: $c-blue-dgray;
}
/*
	##Device = Low Resolution Tablets, Mobiles (Landscape)
	##Screen = B/w 481px to 767px
*/
@media (min-width: 481px) and (max-width: 767px) {
	//css
}
/*
	##Device = Most of the Smartphones Mobiles (Portrait)
	##Screen = B/w 320px to 479px
*/
@media (min-width: $mnWMobile) and (max-width: 480px) {
	//CSS
}
</style>

<style lang="scss" scoped>
@import '@/css/variables.scss';

/*
	##Device = Laptops, Desktops
	##Screen = B/w 1025px to 1280px
*/
@media (min-width: 1025px) and (max-width: 1280px) {
	//CSS
}

/*
	##Device = Tablets, Ipads (portrait)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) {
	//CSS
}

/*
	##Device = Tablets, Ipads (landscape)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
	//CSS
}

/*
	##Device = Low Resolution Tablets, Mobiles (Landscape)
	##Screen = B/w 481px to 767px
*/
@media (min-width: 481px) and (max-width: 767px) {
	//CSS
}

/*
	##Device = Most of the Smartphones Mobiles (Portrait)
	##Screen = B/w 320px to 479px
*/
@media (min-width: $mnWMobile) and (max-width: 480px) {
	//CSS
}
</style>
